import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/ja";

import axios from "axios";
import moment from "moment";
import config from "config";

// Django CSRF Tokenの設定
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

// Font Awesome関連
import "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css";
import "@fortawesome/fontawesome-free-webfonts/css/fa-brands.css";
import "@fortawesome/fontawesome-free-webfonts/css/fa-regular.css";
import "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css";

Vue.use(ElementUI, { locale });
Vue.config.productionTip = false;

Vue.filter("sqlFormatDate", function(value) {
  if (value) {
    return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
  }
});

const configMixin = Vue.mixin({
  created: function () {
    this.$config = config
  }
})

new Vue({
  router,
  store,
  configMixin,
  render: h => h(App)
}).$mount("#app");
